import api from "@/lib/api";

function hHeader() {
  const hid = typeof document !== "undefined" ? document.cookie
    .split(";").map(c => c.trim()).find(c => c.startsWith("active_hotel_id=")) : null;
  const val = hid ? decodeURIComponent(hid.split("=")[1]) : null;
  return val ? { "X-Hocp-Hotel": val } : {};
}
const H = () => ({ headers: hHeader() });

export const mntAPI = {
  dashboard:    ()             => api.get("/mnt/v1/dashboard", H()).then(r => r.data),
  // Categories
  categories:   (params = {})  => api.get("/mnt/v1/categories", { ...H(), params }).then(r => r.data),
  createCategory: (body)       => api.post("/mnt/v1/categories", body, H()).then(r => r.data),
  // Assets
  assets:       (params = {})  => api.get("/mnt/v1/assets", { ...H(), params }).then(r => r.data),
  asset:        (id)           => api.get(`/mnt/v1/assets/${id}`, H()).then(r => r.data),
  createAsset:  (body)         => api.post("/mnt/v1/assets", body, H()).then(r => r.data),
  updateAsset:  (id, body)     => api.patch(`/mnt/v1/assets/${id}`, body, H()).then(r => r.data),
  // Work orders
  wos:          (params = {})  => api.get("/mnt/v1/work-orders", { ...H(), params }).then(r => r.data),
  wo:           (id)           => api.get(`/mnt/v1/work-orders/${id}`, H()).then(r => r.data),
  createWO:     (body)         => api.post("/mnt/v1/work-orders", body, H()).then(r => r.data),
  assignWO:     (id, body)     => api.post(`/mnt/v1/work-orders/${id}/assign`, body, H()).then(r => r.data),
  startWO:      (id)           => api.post(`/mnt/v1/work-orders/${id}/start`, {}, H()).then(r => r.data),
  pauseWO:      (id, body)     => api.post(`/mnt/v1/work-orders/${id}/pause`, body, H()).then(r => r.data),
  completeWO:   (id, body)     => api.post(`/mnt/v1/work-orders/${id}/complete`, body, H()).then(r => r.data),
  closeWO:      (id)           => api.post(`/mnt/v1/work-orders/${id}/close`, {}, H()).then(r => r.data),
  cancelWO:     (id, body)     => api.post(`/mnt/v1/work-orders/${id}/cancel`, body, H()).then(r => r.data),
  commentWO:    (id, body)     => api.post(`/mnt/v1/work-orders/${id}/comment`, body, H()).then(r => r.data),
  // PM
  pms:          (params = {})  => api.get("/mnt/v1/pm", { ...H(), params }).then(r => r.data),
  createPM:     (body)         => api.post("/mnt/v1/pm", body, H()).then(r => r.data),
  updatePM:     (id, body)     => api.patch(`/mnt/v1/pm/${id}`, body, H()).then(r => r.data),
  pmSweep:      ()             => api.post("/mnt/v1/pm/sweep", {}, H()).then(r => r.data),
  // AMC
  amcs:         (params = {})  => api.get("/mnt/v1/amcs", { ...H(), params }).then(r => r.data),
  createAMC:    (body)         => api.post("/mnt/v1/amcs", body, H()).then(r => r.data),
  // Engineers
  engineers:    ()             => api.get("/mnt/v1/engineers", H()).then(r => r.data),
};

export const fmtINR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

// ── Shared UI constants ────────────────────────────────────────────────
export const PRIO_STYLE = {
  emergency: { chip: "bg-rose-500/15 text-rose-300 ring-1 ring-rose-500/30",   dot: "bg-rose-400",    label: "Emergency" },
  high:      { chip: "bg-amber-500/15 text-amber-300 ring-1 ring-amber-500/30", dot: "bg-amber-400",   label: "High" },
  medium:    { chip: "bg-sky-500/15 text-sky-300 ring-1 ring-sky-500/30",       dot: "bg-sky-400",     label: "Medium" },
  low:       { chip: "bg-slate-500/15 text-slate-300 ring-1 ring-slate-500/30", dot: "bg-slate-400",   label: "Low" },
};

export const STATUS_STYLE = {
  submitted:   { chip: "bg-slate-100 text-slate-700",   label: "Submitted" },
  assigned:    { chip: "bg-sky-100 text-sky-700",       label: "Assigned" },
  in_progress: { chip: "bg-amber-100 text-amber-700",   label: "In progress" },
  paused:      { chip: "bg-orange-100 text-orange-700", label: "Paused" },
  completed:   { chip: "bg-emerald-100 text-emerald-700", label: "Completed" },
  closed:      { chip: "bg-slate-100 text-slate-500",   label: "Closed" },
  cancelled:   { chip: "bg-rose-100 text-rose-700",     label: "Cancelled" },
};
